module.exports = __webpack_public_path__ + "static/media/1.e05d91e5.jpg";